import { Component, ViewChild } from '@angular/core';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { Platform, Nav } from 'ionic-angular';

import { GlobalVars } from './app.environment';
import { Role } from '../models/roles';
import { User } from '../models/user';
import { CodeInputPage } from '../pages/code-input/code-input';
import { ConfigurationPage } from '../pages/configuration/configuration';
import { ConfigurationAdminPage } from '../pages/configuration-admin/configuration-admin';
import { HistoryPage } from '../pages/history/history';
import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { ReportSelectionPage } from '../pages/report-selection/report-selection';;
import { TimetablesPage } from '../pages/timetables/timetables';
import { UserHistoryPage } from '../pages/user-history/user-history';
import { UsersPage } from '../pages/users/users';
import { WorkplacesPage } from '../pages/workplaces/workplaces';
import { AuthProvider } from '../providers/auth/auth';
import { FraudsPage } from '../pages/frauds/frauds';
import { UsersStatusPage } from '../pages/users-status/users-status';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild('NAV') nav: Nav;
  
  pages: Array<{title: string, component: any, icon: string}>;
  rootPage:any = LoginPage;
  profileObservable;

  constructor(
    private platform: Platform, 
    private statusBar: StatusBar, 
    private splashScreen: SplashScreen,
    public authProvider: AuthProvider,
    private globalVars: GlobalVars,
  ) {
    this.initializeApp();
  }

  /**
   * Mètode per anar a la pàgina indicada per paràmetre.
   * El cas d'anar a la pàgina login s'ha de fer primer 
   * un logout.
   * 
   * @param page Pàgina a la que es desitja anar.
   */
  goToPage(page: any){
    if(page.name == 'LoginPage') {
      this.authProvider.signOut();
      this.globalVars.user = null;
    }
    
    else if (this.nav.indexOf(page) < 0) {
      this.nav.push(page);
    }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.getMainPage();
    });
  }

  /**
   * Mètode per configurar el menú lateral en funció
   * del rol de l'usuari actual.
   */
  private configRolePages() {
    if (this.globalVars.user.role == Role.normal) {
      this.pages = [
        { title: 'Historial',     component: UserHistoryPage,     icon: 'archive'},
        { title: 'Informes',      component: ReportSelectionPage, icon: 'document'},
        { title: 'Configuración', component: ConfigurationPage,   icon: 'settings'},
        { title: 'Desconectar',   component: LoginPage,           icon: 'power'},
      ]
      console.log('normal user');

    } else if (this.globalVars.user.role == Role.admin) {
      this.pages = [
        { title: 'Pantalla de fichaje', component: HomePage,               icon: 'home'},
        { title: 'Fichajes',            component: HistoryPage,            icon: 'pin'},
        { title: 'Centros de trabajo',  component: WorkplacesPage,         icon: 'hammer'},
        { title: 'Horarios',            component: TimetablesPage,         icon: 'clock'},
        { title: 'Usuarios',            component: UsersPage,              icon: 'people'},
        { title: 'Fraudes',             component: FraudsPage,             icon: 'alert'},
        { title: 'Informes',            component: ReportSelectionPage,    icon: 'document'},
        { title: 'Configuración',       component: ConfigurationAdminPage, icon: 'settings'},
        { title: 'Desconectar',         component: LoginPage,              icon: 'power'},
      ]
      console.log('admin user');
      
    } else {
      this.pages = []
      console.log('unauthorized user');
    }
  }

  private getMainPage() {
    this.authProvider.getProfile().subscribe((user: User) => { 
      this.globalVars.user = user;
      console.log(this.globalVars.user)
      this.goToMainPage();
    });
  }

  private goToMainPage() {
    if(this.globalVars.user.role == Role.admin) this.rootPage = UsersStatusPage;
    else if(this.globalVars.user.role == Role.normal) this.rootPage = HomePage;
    else if(this.globalVars.user.role == Role.checkPoint) this.rootPage = CodeInputPage;
    else this.rootPage = LoginPage;

    this.configRolePages();
    if(this.globalVars.initLoading) this.globalVars.initLoading.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts